import { EziouPage } from '.';

export default {
  path: 'mts',
  childRoutes: [{ path: '', component: EziouPage, isIndex: true }],
};
